// components/ModalWrapper.jsx
import React from "react";

export default function ModalWrapper({ id, children, className = "", classNameForIndex = "tw-z-[2000000002] sm:tw-z-[10000]", style = {} }) {
    const baseClasses = `modal fade ${classNameForIndex}`;
    return (
        <div
            className={`${baseClasses} ${className}`}
            id={id}
            tabIndex={-1}
            aria-hidden="true"
            style={style}
            data-bs-backdrop="static"   // 👈 thêm dòng này
        >
            {children}
        </div>
    );
}
